import React, { useState } from "react";
import { Drawer, Tabs, DatePicker } from "antd";
import { Route, Switch } from "react-router-dom";
import { useToggle } from "../../modules";
import { useHistory } from "react-router-dom/";
import TabPane from "antd/lib/tabs/TabPane";
import NewBed from "../modals/newBed";

const { RangePicker } = DatePicker;

const BedReturn = () => {
  const [ranges, setRanges] = useState();

  const selectRange = (range) => {
    setRanges(range);
  };

  return (
    <>
      <div className="overflow-x-auto">
        <RangePicker onChange={selectRange} />
        <table className="table-auto w-full mt-4">
          <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
            <tr>
              <th className="p-2">
                <div className="font-semibold text-center"> </div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">Beds</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">Cots</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">Totals</div>
              </th>
            </tr>
          </thead>

          <tbody className="text-sm font-medium divide-y divide-gray-100">
            <tr>
              <td className="p-2">
                <div className="text-center font-bold">Patients</div>
              </td>
              <td className="p-2">
                <div className="text-left">10</div>
              </td>
              <td className="p-2">
                <div className="text-left">20</div>
              </td>
              <td className="p-2">
                <div className="text-left">30</div>
              </td>
            </tr>
            <tr>
              <td className="p-2">
                <div className="text-center font-bold">Discharge In</div>
              </td>
              <td className="p-2">
                <div className="text-left">10</div>
              </td>
              <td className="p-2">
                <div className="text-left">20</div>
              </td>
              <td className="p-2">
                <div className="text-left">30</div>
              </td>
            </tr>
            <tr>
              <td className="p-2">
                <div className="text-center font-bold">Vacants</div>
              </td>
              <td className="p-2">
                <div className="text-left">10</div>
              </td>
              <td className="p-2">
                <div className="text-left">20</div>
              </td>
              <td className="p-2">
                <div className="text-left">30</div>
              </td>
            </tr>
            <tr>
              <td className="p-2">
                <div className="text-center font-bold">Total</div>
              </td>
              <td className="p-2">
                <div className="text-left">10</div>
              </td>
              <td className="p-2">
                <div className="text-left">20</div>
              </td>
              <td className="p-2">
                <div className="text-left">30</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

const Transfers = () => {
  const [ranges, setRanges] = useState();

  const selectRange = (range) => {
    setRanges(range);
  };
  return (
    <>
      <div className="overflow-x-auto">
        <RangePicker onChange={selectRange} />

        <div className="mb-4 mt-4">
          <p className="font-extrabold text-xl mb-0">Transfered In</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Added on</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">From</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">To</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div>
          <p className="font-extrabold text-xl mb-0">Transfered Out</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Added on</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">From</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">To</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
};

const Leave = () => {
  const [ranges, setRanges] = useState();

  const selectRange = (range) => {
    setRanges(range);
  };
  return (
    <>
      <div className="overflow-x-auto">
        <RangePicker onChange={selectRange} />

        <div className="mb-4 mt-4">
          <p className="font-extrabold text-xl mb-0">From Leave</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Added on</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Left On</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Return Date</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div>
          <p className="font-extrabold text-xl mb-0">To Leave</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Added on</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Left On</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Return Date</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
};

const Abscondees = () => {
  const [ranges, setRanges] = useState();

  const selectRange = (range) => {
    setRanges(range);
  };
  return (
    <>
      <div className="overflow-x-auto">
        <RangePicker onChange={selectRange} />

        <div className="mb-4 mt-4">
          <p className="font-extrabold text-xl mb-0">Returned</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Added on</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Left On</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Return Date</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div>
          <p className="font-extrabold text-xl mb-0">Discharged</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Added on</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Left On</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Return Date</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
};

const Admissions = () => {
  const [ranges, setRanges] = useState();

  const selectRange = (range) => {
    setRanges(range);
  };
  return (
    <>
      <div className="overflow-x-auto">
        <RangePicker onChange={selectRange} />

        <div className="mb-4 mt-4">
          <p className="font-extrabold text-xl mb-0">Returned</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Status</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Tmeline</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
};

const Discharges = () => {
  const [ranges, setRanges] = useState();

  const selectRange = (range) => {
    setRanges(range);
  };

  return (
    <>
      <div className="overflow-x-auto">
        <RangePicker onChange={selectRange} />

        <div className="mb-4 mt-4">
          <p className="font-extrabold text-xl mb-0">Returned</p>
          <table className="table-auto w-full mt-4">
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-center">No</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Patient Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Status</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Tmeline</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </>
  );
};
const Ward = () => {
  const history = useHistory();
  const [visible, toggleVisible] = useToggle(true);

  const [newBedModal, toggleNewBedModal] = useToggle();

  const close = () => {
    toggleVisible();
    setTimeout(() => history.goBack(), 100);
  };

  return (
    <Drawer
      closable
      maskClosable
      title="Statistics"
      placement="right"
      width="70%"
      onClose={close}
      visible={visible}
    >
      <div>
        <Tabs>
          <TabPane key="1" tab="Beds">
            <div className="grid grid-cols-1 mt-3 mb-4">
              {newBedModal && (
                <NewBed visible={newBedModal} toggle={toggleNewBedModal} />
              )}
              <div lassName="flex flex-col justify-between mb-6 px-1 pt-3 pb-3">
                <label className="mr-4 text-gray-500 text-lg font-bold mb-2">
                  Total:
                </label>
                <span>20</span>
              </div>
              <div lassName="flex flex-col justify-between mb-4 px-1 pt-3 pb-1">
                <label className="mr-4 text-gray-500 text-lg font-bold mb-2">
                  Occupied:
                </label>
                <span>10</span>
              </div>
              <div lassName="flex flex-col justify-between mb-4 px-1 pt-3 pb-1">
                <label className="mr-4 text-gray-500 text-lg font-bold mb-2">
                  Vacant:
                </label>
                <span>10</span>
              </div>
              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                <button
                  onClick={toggleNewBedModal}
                  className="btn hisani-btn-green-light text-white"
                >
                  <svg
                    className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="hidden xs:block ml-2">Add New Bed</span>
                </button>
              </div>
            </div>
          </TabPane>
          <TabPane key="2" tab="Admissions">
            <Admissions />
          </TabPane>
          <TabPane key="3" tab="Discharges">
            <Discharges />
          </TabPane>
          <TabPane key="4" tab="Daily Bed Return">
            <BedReturn />
          </TabPane>
          <TabPane key="5" tab="Transfers">
            <Transfers />
          </TabPane>
          <TabPane key="6" tab="On Leave">
            <Leave />
          </TabPane>
          <TabPane key="7" tab="Abscondees">
            <Abscondees />
          </TabPane>
        </Tabs>
      </div>
    </Drawer>
  );
};

export default Ward;